import type { CSS } from '@stitches/react';
import { memo } from 'react';

import { CarModel } from '@/components/sections/product-compare/car-selection-card';
import { Divider } from '@/components/shared/element/divider';
import { Text } from '@/components/shared/element/text';
import { ColorSelection } from '@/components/shared/form/color-selection';
import { ColorSelectionDetail } from '@/components/shared/form/color-selection/color-selection-detail';
import { Flex } from '@/components/shared/layout/flex';
import { styled } from '@/stitches.config';
import { ILCVModelColor } from '@/types/lcv/model';

export const CarSelectionDetailStyled = styled(Flex, {
  paddingTop: '$space-2',
  margin: '0 auto',
  maxWidth: 360,
  width: '100%',
  height: '100%',
});

interface CarSelectionDetailProps {
  css?: CSS;
  showColor?: boolean;
  disabledColor?: boolean;
  index: number;
  model: CarModel;
  onChangeModelColor?: (color: ILCVModelColor) => void;
}

export const CarSelectionDetail: React.FC<CarSelectionDetailProps> = memo(
  ({ css, index, model, onChangeModelColor, showColor, disabledColor }) => {
    return (
      <>
        <Flex
          direction="column"
          alignItems="center"
          gap={1}
          css={{ textAlign: 'center', ...css }}
          data-test={`panel_modelDetail_${index}`}
        >
          <Text
            data-test={`model_category_${index}`}
            size="text-body-1"
            font="bold"
            variant="text-gray-darkest"
          >
            {model?.modelCategory}
          </Text>

          {!!model?.modelName && (
            <Text
              data-test={`model_name_${index}`}
              size="text-body-2"
              variant="text-gray-darkest"
            >
              {model?.modelName}
            </Text>
          )}
        </Flex>

        {!!disabledColor && (
          <>
            <ColorSelection
              css={css}
              size="sm"
              show={showColor}
              color={model?.modelColor}
              model={model}
              onClick={onChangeModelColor}
              isShowDetail={false}
              dataTrack="product-compare"
              dataTest={`panel_vehicleColor_${index}`}
            />
            <ColorSelectionDetail
              css={css}
              justify="center"
              color={model?.modelColor}
              show={showColor}
              dataTest={`panel_vehicleDetail_${index}`}
            />
          </>
        )}
        <Divider css={css} />
      </>
    );
  }
);

CarSelectionDetail.displayName = 'CarSelectionDetail';
